module.exports = __webpack_public_path__ + "media/images/icon/handshake-942447d1875307f5b8f278ec0cb3eb1c.png";